import script from "./DataStoreTables.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataStoreTables.vue?vue&type=script&setup=true&lang=ts"

import "./DataStoreTables.vue?vue&type=style&index=0&id=682e10db&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-682e10db"]])

export default __exports__